__turbopack_context__.v({
  "action": "person-details-module-scss-module__Yc5FMG__action",
  "action--selected": "person-details-module-scss-module__Yc5FMG__action--selected",
  "actions": "person-details-module-scss-module__Yc5FMG__actions",
  "address": "person-details-module-scss-module__Yc5FMG__address",
  "author-link": "person-details-module-scss-module__Yc5FMG__author-link",
  "content": "person-details-module-scss-module__Yc5FMG__content",
  "content-wrapper": "person-details-module-scss-module__Yc5FMG__content-wrapper",
  "divider": "person-details-module-scss-module__Yc5FMG__divider",
  "info": "person-details-module-scss-module__Yc5FMG__info",
  "member": "person-details-module-scss-module__Yc5FMG__member",
  "modal": "person-details-module-scss-module__Yc5FMG__modal",
  "modal__buttons": "person-details-module-scss-module__Yc5FMG__modal__buttons",
  "modal__close-button": "person-details-module-scss-module__Yc5FMG__modal__close-button",
  "modal__content": "person-details-module-scss-module__Yc5FMG__modal__content",
  "modal__footer": "person-details-module-scss-module__Yc5FMG__modal__footer",
  "modal__header": "person-details-module-scss-module__Yc5FMG__modal__header",
  "modal__wrapper": "person-details-module-scss-module__Yc5FMG__modal__wrapper",
  "title": "person-details-module-scss-module__Yc5FMG__title",
  "wrapper": "person-details-module-scss-module__Yc5FMG__wrapper",
});
